export default (state, subject, year) => {
  const { indexedYml } = state;
  return indexedYml[year][subject].length;
};
